export default {
  'pages.memberList.title': 'Member List',
  'pages.memberList.create': 'Create Member',
  'pages.memberList.exportCustomer': 'Export Customer',
  'pages.memberList.exportRetailCustomerTitle': 'Export Retail Customer',
  'pages.memberList.create.title': 'Create Member',
  'pages.memberList.firstName': 'First Name',
  'pages.memberList.firstName.required': 'Please enter first name',
  'pages.memberList.middleName': 'Middle Name',
  'pages.memberList.lastName': 'Last Name',
  'pages.memberList.lastName.required': 'Please enter last name',
  'pages.memberList.allowNameEdit': 'Allow Name Editing',
  'pages.memberList.allowNameEdit.help': 'Use this permission to distinguish regular customers from Staff & Trade Members.',
  'pages.memberList.memberId': 'Member ID',
  'pages.memberList.name': 'Name',
  'pages.memberList.phone': 'Phone Number',
  'pages.memberList.phone.required': 'Please enter phone number',
  'pages.memberList.phone.invalid': 'Please enter a valid phone number',
  'pages.memberList.email': 'Email',
  'pages.memberList.email.invalid': 'Please enter a valid email address',
  'pages.memberList.email.maxLength': 'Email cannot exceed 255 characters',
  'pages.memberList.birthday': 'Birthday',
  'pages.memberList.notes': 'Notes',
  'pages.memberList.level': 'Membership Level',
  'pages.memberList.level.required': 'Please select membership level',
  'pages.memberList.level.discount': 'Discount',
  'pages.memberList.customizeDiscount': 'Customize Discount',
  'pages.memberList.customizeDiscount.required': 'Please enter customize discount',
  'pages.memberList.customizeDiscount.invalid': 'Customize Discount must be between 0 and 100',
  'pages.memberList.points': 'Points',
  'pages.memberList.status': 'Status',
  'pages.memberList.status.active': 'Active',
  'pages.memberList.status.inactive': 'Inactive',
  'pages.memberList.actions': 'Actions',
  'pages.memberList.actions.details': 'Details',
  'pages.memberList.create.success': 'Member created successfully',
  'pages.memberList.headoffice.error': 'Failed to get head office information',
  'pages.memberList.level.fetch.error': 'Failed to fetch membership levels',
  'pages.memberList.search.info': 'Search Info',
  'pages.memberList.search.memberId.placeholder': 'Enter member ID',
  'pages.memberList.search.info.placeholder': 'Enter search information',
  'pages.memberList.search.level.placeholder': 'Select membership level',
  'pages.memberList.search.submit': 'Search',
  'pages.memberList.search.reset': 'Reset',
  'pages.memberList.search.refresh': 'Refresh',
  'pages.memberList.total': 'Total',
  'pages.memberList.items': 'items',
  'pages.memberList.pagination.total': 'Total {total} items',
  'pages.memberList.pagination.pageSize': '/page',
  'pages.memberList.pagination.jump': 'Go to',
  'pages.memberList.pagination.page': 'Page',
  'pages.memberList.rewardEnabled': 'Enable Reward Points',
  'pages.memberList.hasExistingMemberId': 'Has Existing Member ID',
  'pages.memberList.existingMemberId': 'Member ID',
  'pages.memberList.existingMemberId.required': 'Please enter member ID',
  'pages.memberList.existingMemberId.invalid': 'Please enter a valid member ID (letters and numbers only)',
  'pages.memberList.existingMemberId.maxLength': 'Member ID maximum length is 15 characters',
  'pages.memberList.existingMemberId.placeholder': 'Enter existing member ID',
  'pages.memberList.cardNumber': 'Card Number',
  'pages.memberList.cardNumber.invalid': 'Up to 20 letters or digits',
  'pages.memberList.cardNumber.placeholder': 'Optional, up to 20 letters or digits',
  'pages.memberList.cardNumber.help': 'Searchable in Enrich POS like the member ID. Must be unique in this head office. Leave empty to remove.',
  'pages.memberList.search.memberIdOrCard.placeholder': 'Enter member ID or card number',
};
